import { UserFormValues } from 'types/state';

export const createUserFormValues = (): UserFormValues => ({
  password: '',
  passwordConfirm: '',
  phoneNumber: null,
  deleted: false
});
